import OutdatedAlbumFolderModal from './modal';

export default OutdatedAlbumFolderModal;
